






















import Vue from 'vue'
import Forms from './Forms.vue'

export default Vue.extend({
  $_veeValidate: {
    validator: 'new'
  },
  components: {
    Forms,
  },
  data () {
    return {
      authenticated: false,
      loggingIn: true,
      password: '',
      error: '',
    }
  },
  methods: {
    submitLogin (event: Event) {
      event.preventDefault()
      this.login()
    },
    login () {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.loggingIn = true
          this.error = ''

          this.$store.dispatch('login', this.password).then(() => {
            this.authenticated = true
            this.loggingIn = false
          }).catch(error => {
            this.loggingIn = false
            if (!error.response) {
              this.error = 'Får ikke kontakt med server. Kontakt administrator.'
            } else if (error.response.data.error === 'wrong_pw') {
              this.error = 'Ugyldig passord'
            } else {
              this.error = 'Ukjent feil. Kontakt administrator.'
            }
          })
        }
      })
    }
  },
  mounted () {
    this.$store.dispatch('isLoggedIn').then(loggedIn => {
      if (loggedIn) {
        this.authenticated = true
      }

      this.loggingIn = false
    }).catch(() => {
      this.loggingIn = false
      this.error = 'Noe galt hendte... prøv igjen'
    })
  },
})
